import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaTrash, FaUserPlus, FaEdit, FaSave, FaGlobe } from 'react-icons/fa';
import api from '../services/api';
import authService from '../services/authService';
import { BASE_URL } from '../services/api';

const SettingsPage = () => {
  // Logo State
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // PDF Logo State
  const [pdfLogo, setPdfLogo] = useState(null);
  const [pdfPreview, setPdfPreview] = useState(null);
  const [loadingPdfLogo, setLoadingPdfLogo] = useState(false);

  // Login BG State
  const [loginBg, setLoginBg] = useState(null);
  const [loginBgPreview, setLoginBgPreview] = useState(null);
  const [loadingLoginBg, setLoadingLoginBg] = useState(false);

  // Login Logo State
  const [loginLogo, setLoginLogo] = useState(null);
  const [loginLogoPreview, setLoginLogoPreview] = useState(null);
  const [loadingLoginLogo, setLoadingLoginLogo] = useState(false);
  
  // Resim Yükleme Hata Durumları
  const [logoError, setLogoError] = useState(false);
  const [pdfLogoError, setPdfLogoError] = useState(false);
  const [loginBgError, setLoginBgError] = useState(false);
  const [loginLogoError, setLoginLogoError] = useState(false);

  // Genel Ayarlar State
  const [settings, setSettings] = useState({
    site_title: '',
    company_name: '',
    company_email: '',
    company_phone: '',
    company_address: ''
  });
  const [favicon, setFavicon] = useState(null);
  const [loadingSettings, setLoadingSettings] = useState(false);

  // Kullanıcı Yönetimi State
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ 
    full_name: '', 
    email: '', 
    password: '', 
    role: 'personel',
    is_active: 1,
    permissions: {
      offers: { view: false, create: false, edit: false, delete: false },
      products: { view: false, create: false, edit: false, delete: false },
      current_accounts: { view: false, create: false, edit: false, delete: false },
      payments: { view: false, create: false, edit: false, delete: false },
      sales: { view: false, create: false, edit: false, delete: false }
    }
  });
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [editingUser, setEditingUser] = useState(null); // Düzenlenen kullanıcı state'i

  // Kullanıcıları Yükle
  const fetchUsers = async () => {
    try {
      const data = await authService.getAllUsers();
      setUsers(data);
      setIsAdmin(true); // Eğer veri çekebiliyorsa admindir (backend kontrolü var)
    } catch (error) {
      // Yetkisi yoksa sessizce geç veya state güncelleme
      setIsAdmin(false);
    }
  };

  // Ayarları Yükle
  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSettings(prev => ({
        ...prev,
        ...response.data
      }));
      
      // Site başlığını güncelle
      if (response.data.site_title) {
        document.title = response.data.site_title; // Tarayıcı başlığını güncelle
      }
    } catch (error) {
      console.error('Ayarlar yüklenemedi:', error);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchSettings();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handlePdfFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPdfLogo(file);
      setPdfPreview(URL.createObjectURL(file));
    }
  };

  const handleLoginBgChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLoginBg(file);
      setLoginBgPreview(URL.createObjectURL(file));
    }
  };

  const handleLoginLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLoginLogo(file);
      setLoginLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleFaviconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFavicon(file);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!logo) {
      toast.warning('Lütfen bir resim seçiniz.');
      return;
    }

    const formData = new FormData();
    formData.append('logo', logo);

    setLoading(true);
    try {
      await api.post('/settings/logo', formData, {
        headers: {
          'Content-Type': undefined
        }
      });
      toast.success('Logo başarıyla güncellendi. Sayfa yenileniyor...');
      
      // Logunun güncellendiğini görmek için sayfayı yenile
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Logo Upload Error:", error);
      const message = error.response?.data?.message || 'Logo yüklenirken hata oluştu.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handlePdfUpload = async (e) => {
    e.preventDefault();
    if (!pdfLogo) {
      toast.warning('Lütfen bir resim seçiniz.');
      return;
    }

    const formData = new FormData();
    formData.append('pdfLogo', pdfLogo);

    setLoadingPdfLogo(true);
    try {
      await api.post('/settings/pdf-logo', formData, {
        headers: {
          'Content-Type': undefined
        }
      });
      toast.success('PDF Logosu başarıyla güncellendi. Sayfa yenileniyor...');
      
      // Logunun güncellendiğini görmek için sayfayı yenile
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("PDF Logo Upload Error:", error);
      const message = error.response?.data?.message || 'Logo yüklenirken hata oluştu.';
      toast.error(message);
    } finally {
      setLoadingPdfLogo(false);
    }
  };

  const handleLoginBgUpload = async (e) => {
    e.preventDefault();
    if (!loginBg) {
      toast.warning('Lütfen bir resim seçiniz.');
      return;
    }

    const formData = new FormData();
    formData.append('loginBg', loginBg);

    setLoadingLoginBg(true);
    try {
      await api.post('/settings/login-bg', formData, {
        headers: {
          'Content-Type': undefined
        }
      });
      toast.success('Giriş ekranı görseli güncellendi. Sayfa yenileniyor...');
      
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Login BG Upload Error:", error);
      toast.error('Görsel yüklenirken hata oluştu.');
    } finally {
      setLoadingLoginBg(false);
    }
  };

  const handleLoginLogoUpload = async (e) => {
    e.preventDefault();
    if (!loginLogo) {
      toast.warning('Lütfen bir resim seçiniz.');
      return;
    }

    const formData = new FormData();
    formData.append('loginLogo', loginLogo);

    setLoadingLoginLogo(true);
    try {
      await api.post('/settings/login-logo', formData, {
        headers: {
          'Content-Type': undefined
        }
      });
      toast.success('Giriş ekranı logosu güncellendi. Sayfa yenileniyor...');
      
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Login Logo Upload Error:", error);
      toast.error('Logo yüklenirken hata oluştu.');
    } finally {
      setLoadingLoginLogo(false);
    }
  };

  const handleSettingsUpdate = async (e) => {
    e.preventDefault();
    setLoadingSettings(true);
    try {
      // 1. Site Başlığını Güncelle
      await api.put('/settings', settings);
      
      // 2. Favicon Varsa Yükle
      if (favicon) {
        const formData = new FormData();
        formData.append('favicon', favicon);
        await api.post('/settings/favicon', formData, {
          headers: { 'Content-Type': undefined }
        });
      }

      toast.success('Ayarlar güncellendi.');
      
      // Değişiklikleri yansıtmak için sayfayı yenile
      setTimeout(() => window.location.reload(), 1000);

    } catch (error) {
      toast.error('Ayarlar güncellenirken hata oluştu.');
    } finally {
      setLoadingSettings(false);
    }
  };

  const handleSettingChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setLoadingUsers(true);
    try {
      await authService.register(newUser);
      toast.success('Kullanıcı başarıyla oluşturuldu.');
      setNewUser({ 
        full_name: '', 
        email: '', 
        password: '', 
        role: 'personel',
        permissions: {
          offers: { view: false, create: false, edit: false, delete: false },
          products: { view: false, create: false, edit: false, delete: false },
          current_accounts: { view: false, create: false, edit: false, delete: false },
          payments: { view: false, create: false, edit: false, delete: false },
          sales: { view: false, create: false, edit: false, delete: false }
        }
      });
      fetchUsers();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Kullanıcı oluşturulamadı.');
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleDeleteUser = async (id) => {
    if (window.confirm('Bu kullanıcıyı silmek istediğinize emin misiniz?')) {
      try {
        await authService.deleteUser(id);
        toast.success('Kullanıcı silindi.');
        fetchUsers();
      } catch (error) {
        toast.error(error.response?.data?.message || 'Silme işlemi başarısız.');
      }
    }
  };

  // İzin Checkbox Değişimi
  const handlePermissionChange = (resource, action) => {
    setNewUser(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [resource]: {
          ...(prev.permissions[resource] || { view: false, create: false, edit: false, delete: false }),
          [action]: prev.permissions[resource] ? !prev.permissions[resource][action] : true
        }
      }
    }));
  };

  // --- DÜZENLEME İŞLEMLERİ ---
  const handleEditClick = (user) => {
    // Varsayılan izin şablonu
    const defaultPermissions = {
      offers: { view: false, create: false, edit: false, delete: false },
      products: { view: false, create: false, edit: false, delete: false },
      current_accounts: { view: false, create: false, edit: false, delete: false },
      payments: { view: false, create: false, edit: false, delete: false },
      sales: { view: false, create: false, edit: false, delete: false }
    };

    // Mevcut izinlerle varsayılanları birleştir (Eksik olanları tamamla)
    const currentPermissions = user.permissions || {};
    const mergedPermissions = {};
    
    // Tüm kaynaklar için döngü (defaultPermissions anahtarları üzerinden)
    Object.keys(defaultPermissions).forEach(key => {
      mergedPermissions[key] = { 
        ...defaultPermissions[key], 
        ...(currentPermissions[key] || {}) 
      };
    });

    setEditingUser({
      ...user,
      password: '', 
      is_active: user.is_active,
      permissions: mergedPermissions
    });
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/auth/users/${editingUser.id}`, editingUser);
      toast.success('Kullanıcı güncellendi.');
      setEditingUser(null);
      fetchUsers();
    } catch (error) {
      toast.error('Güncelleme başarısız.');
    }
  };

  const handleEditPermissionChange = (resource, action) => {
    setEditingUser(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [resource]: {
          ...(prev.permissions[resource] || { view: false, create: false, edit: false, delete: false }),
          [action]: prev.permissions[resource] ? !prev.permissions[resource][action] : true
        }
      }
    }));
  };

  const resources = [
    { key: 'offers', label: 'Teklifler' },
    { key: 'sales', label: 'Satışlar' },
    { key: 'products', label: 'Ürünler & Stok' },
    { key: 'current_accounts', label: 'Cari Hesaplar' },
    { key: 'payments', label: 'Tahsilat/Ödeme' }
  ];

  return (
    <div className="container-fluid">
      <h2 className="mb-4 text-secondary">Ayarlar & Kullanıcı Yönetimi</h2>
      
      <div className="row">
        {/* Genel Ayarlar & Görünüm */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom-0 pt-4 ps-4">
              <h5 className="mb-0 text-primary fw-bold">Site Görünümü & Ayarlar</h5>
            </div>
            <div className="card-body p-4">
              
              {/* Logo Yükleme */}
              <form onSubmit={handleUpload} className="mb-4 border-bottom pb-4">
                <h6 className="fw-bold mb-3">Şirket Logosu (Site)</h6>
                <div className="mb-4 text-center">
                  <div className="border rounded p-3 bg-light d-inline-block" style={{ minWidth: '200px', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {preview ? (
                      <img src={preview} alt="Önizleme" style={{ maxHeight: '80px', maxWidth: '100%' }} />
                    ) : !logoError ? (
                      <img 
                        src={`${BASE_URL}/uploads/logo.png?v=${new Date().getTime()}`} 
                        alt="Mevcut Logo" 
                        style={{ maxHeight: '80px', maxWidth: '100%' }} 
                        onError={() => setLogoError(true)}
                      />
                    ) : (
                      <span className="text-muted small">Logo Yok</span>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <input type="file" className="form-control" onChange={handleFileChange} accept="image/*" />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? 'Yükleniyor...' : 'Logoyu Kaydet'}
                </button>
              </form>

              {/* PDF Logo Yükleme */}
              <form onSubmit={handlePdfUpload} className="mb-4 border-bottom pb-4">
                <h6 className="fw-bold mb-3">PDF Logosu (Teklif/Ekstre)</h6>
                <div className="mb-4 text-center">
                  <div className="border rounded p-3 bg-light d-inline-block" style={{ minWidth: '200px', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {pdfPreview ? (
                      <img src={pdfPreview} alt="Önizleme" style={{ maxHeight: '80px', maxWidth: '100%' }} />
                    ) : !pdfLogoError ? (
                      <img 
                        src={`${BASE_URL}/uploads/pdf-logo.png?v=${new Date().getTime()}`} 
                        alt="PDF Logosu" 
                        style={{ maxHeight: '80px', maxWidth: '100%' }} 
                        onError={() => setPdfLogoError(true)}
                      />
                    ) : (
                      <span className="text-muted small">PDF Logosu Yok</span>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <input type="file" className="form-control" onChange={handlePdfFileChange} accept="image/*" />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loadingPdfLogo}>
                  {loadingPdfLogo ? 'Yükleniyor...' : 'PDF Logosunu Kaydet'}
                </button>
              </form>

              {/* Login BG Yükleme */}
              <form onSubmit={handleLoginBgUpload} className="mb-4 border-bottom pb-4">
                <h6 className="fw-bold mb-3">Giriş Ekranı Görseli (Sol Taraf)</h6>
                <div className="mb-4 text-center">
                  <div className="border rounded p-3 bg-light d-inline-block" style={{ minWidth: '200px', minHeight: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {loginBgPreview ? (
                      <img src={loginBgPreview} alt="Önizleme" style={{ maxHeight: '120px', maxWidth: '100%' }} />
                    ) : !loginBgError ? (
                      <img 
                        src={`${BASE_URL}/uploads/login-bg.jpg?v=${new Date().getTime()}`} 
                        alt="Mevcut Görsel" 
                        style={{ maxHeight: '120px', maxWidth: '100%' }} 
                        onError={() => setLoginBgError(true)}
                      />
                    ) : (
                      <span className="text-muted small">Görsel Yok</span>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <input type="file" className="form-control" onChange={handleLoginBgChange} accept="image/*" />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loadingLoginBg}>
                  {loadingLoginBg ? 'Yükleniyor...' : 'Görseli Kaydet'}
                </button>
              </form>

              {/* Login Logo Yükleme */}
              <form onSubmit={handleLoginLogoUpload} className="mb-4 border-bottom pb-4">
                <h6 className="fw-bold mb-3">Giriş Ekranı Logosu (Form Üstü)</h6>
                <div className="mb-4 text-center">
                  <div className="border rounded p-3 bg-light d-inline-block" style={{ minWidth: '200px', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {loginLogoPreview ? (
                      <img src={loginLogoPreview} alt="Önizleme" style={{ maxHeight: '80px', maxWidth: '100%' }} />
                    ) : !loginLogoError ? (
                      <img 
                        src={`${BASE_URL}/uploads/login-logo.png?v=${new Date().getTime()}`} 
                        alt="Mevcut Giriş Logosu" 
                        style={{ maxHeight: '80px', maxWidth: '100%' }} 
                        onError={() => setLoginLogoError(true)}
                      />
                    ) : (
                      <span className="text-muted small">Özel Logo Yok (Varsayılan Kullanılır)</span>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <input type="file" className="form-control" onChange={handleLoginLogoChange} accept="image/*" />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loadingLoginLogo}>
                  {loadingLoginLogo ? 'Yükleniyor...' : 'Giriş Logosunu Kaydet'}
                </button>
              </form>

              {/* Genel Ayarlar Formu */}
              <form onSubmit={handleSettingsUpdate}>
                <h6 className="fw-bold mb-3">Genel Bilgiler</h6>
                
                <div className="mb-3">
                  <label className="form-label">Site Başlığı</label>
                  <div className="input-group">
                    <span className="input-group-text"><FaGlobe /></span>
                    <input type="text" name="site_title" className="form-control" value={settings.site_title || ''} onChange={handleSettingChange} placeholder="Örn: Saka Pelet" />
                  </div>
                </div>

                <h6 className="fw-bold mb-3 mt-4">Firma Bilgileri (PDF İçin)</h6>
                
                <div className="mb-3">
                  <label className="form-label">Firma Adı</label>
                  <input type="text" name="company_name" className="form-control" value={settings.company_name || ''} onChange={handleSettingChange} placeholder="Firma Adı" />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">E-posta</label>
                    <input type="email" name="company_email" className="form-control" value={settings.company_email || ''} onChange={handleSettingChange} placeholder="E-posta Adresi" />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Telefon</label>
                    <input type="text" name="company_phone" className="form-control" value={settings.company_phone || ''} onChange={handleSettingChange} placeholder="Telefon Numarası" />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Adres</label>
                  <textarea name="company_address" className="form-control" rows="2" value={settings.company_address || ''} onChange={handleSettingChange} placeholder="Adres Bilgisi"></textarea>
                </div>

                <div className="mb-3 mt-4">
                  <label className="form-label">Favicon (Tarayıcı İkonu)</label>
                  <input type="file" className="form-control" onChange={handleFaviconChange} accept=".ico,.png" />
                  <small className="text-muted">Önerilen: .ico veya .png formatı</small>
                </div>

                <button type="submit" className="btn btn-success w-100" disabled={loadingSettings}>
                  <FaSave className="me-2" /> {loadingSettings ? 'Kaydediliyor...' : 'Ayarları Güncelle'}
                </button>
              </form>

            </div>
          </div>
        </div>

        {/* Kullanıcı Yönetimi Alanı (Sadece Admin Görebilir) */}
        {isAdmin && (
          <div className="col-md-6">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-bottom-0 pt-4 ps-4">
                <h5 className="mb-0 text-primary fw-bold">Yeni Kullanıcı Ekle</h5>
              </div>
              <div className="card-body p-4">
                <form onSubmit={handleCreateUser}>
                  <div className="mb-3">
                    <label className="form-label">Ad Soyad</label>
                    <input type="text" className="form-control" value={newUser.full_name} onChange={(e) => setNewUser({...newUser, full_name: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">E-posta</label>
                    <input type="email" className="form-control" value={newUser.email} onChange={(e) => setNewUser({...newUser, email: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Şifre</label>
                    <input type="password" className="form-control" value={newUser.password} onChange={(e) => setNewUser({...newUser, password: e.target.value})} required minLength="6" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Rol</label>
                    <select className="form-select" value={newUser.role} onChange={(e) => setNewUser({...newUser, role: e.target.value})}>
                      <option value="personel">Personel</option>
                      <option value="muhasebe">Muhasebe</option>
                      <option value="admin">Admin</option>
                      <option value="bayi">Bayi</option>
                    </select>
                  </div>

                  {/* İzinler Tablosu (Sadece Personel veya Muhasebe seçiliyse gösterilebilir) */}
                  {newUser.role !== 'admin' && (
                    <div className="mb-3">
                      <label className="form-label fw-bold">Erişim İzinleri</label>
                      <div className="table-responsive border rounded p-2 bg-light">
                        <table className="table table-sm table-borderless mb-0">
                          <thead>
                            <tr>
                              <th>Sayfa</th>
                              <th className="text-center">Gör</th>
                              <th className="text-center">Ekle</th>
                              <th className="text-center">Düz</th>
                              <th className="text-center">Sil</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resources.map(res => (
                              <tr key={res.key}>
                                <td>{res.label}</td>
                                {['view', 'create', 'edit', 'delete'].map(action => (
                                  <td key={action} className="text-center">
                                    <input 
                                      type="checkbox" 
                                      className="form-check-input"
                                      checked={newUser.permissions[res.key] ? newUser.permissions[res.key][action] : false}
                                      onChange={() => handlePermissionChange(res.key, action)}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <small className="text-muted">* Admin rolü tüm yetkilere sahiptir.</small>
                    </div>
                  )}

                  <button type="submit" className="btn btn-success w-100" disabled={loadingUsers}>
                    <FaUserPlus className="me-2" /> {loadingUsers ? 'Ekleniyor...' : 'Kullanıcı Ekle'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Kullanıcı Listesi */}
      {isAdmin && (
        <div className="row mt-4">
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-bottom-0 pt-4 ps-4">
                <h5 className="mb-0 text-secondary fw-bold">Kullanıcı Listesi</h5>
              </div>
              <div className="card-body p-4">
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Ad Soyad</th>
                        <th>E-posta</th>
                         <th>Durum</th>
                        <th>Rol</th>
                        <th>Kayıt Tarihi</th>
                        <th>İşlem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map(user => (
                        <tr key={user.id}>
                          <td>{user.full_name}</td>
                          <td>{user.email}</td>
                           <td>{user.is_active ? <span className="badge bg-success">Aktif</span> : <span className="badge bg-secondary">Pasif</span>}</td>
                          <td><span className={`badge ${user.role === 'admin' ? 'bg-danger' : user.role === 'muhasebe' ? 'bg-warning' : 'bg-info'}`}>{user.role.toUpperCase()}</span></td>
                          <td>{new Date(user.created_at).toLocaleDateString('tr-TR')}</td>
                          <td>
                            <button onClick={() => handleEditClick(user)} className="btn btn-sm btn-outline-primary me-2"><FaEdit /></button>
                            <button onClick={() => handleDeleteUser(user.id)} className="btn btn-sm btn-outline-danger"><FaTrash /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DÜZENLEME MODALI */}
      {editingUser && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Kullanıcı Düzenle</h5>
                <button type="button" className="btn-close" onClick={() => setEditingUser(null)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpdateUser}>
                  <div className="mb-3">
                    <label className="form-label">Ad Soyad</label>
                    <input type="text" className="form-control" value={editingUser.full_name} onChange={(e) => setEditingUser({...editingUser, full_name: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">E-posta</label>
                    <input type="email" className="form-control" value={editingUser.email} onChange={(e) => setEditingUser({...editingUser, email: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Yeni Şifre (Değiştirmek istemiyorsanız boş bırakın)</label>
                    <input type="password" className="form-control" value={editingUser.password} onChange={(e) => setEditingUser({...editingUser, password: e.target.value})} minLength="6" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Rol</label>
                    <select className="form-select" value={editingUser.role} onChange={(e) => setEditingUser({...editingUser, role: e.target.value})}>
                      <option value="personel">Personel</option>
                      <option value="muhasebe">Muhasebe</option>
                      <option value="admin">Admin</option>
                      <option value="bayi">Bayi</option>
                    </select>
                  </div>
                  
                  <div className="mb-3 form-check form-switch">
                    <input className="form-check-input" type="checkbox" id="isActiveEdit" checked={editingUser.is_active} onChange={(e) => setEditingUser({...editingUser, is_active: e.target.checked ? 1 : 0})} />
                    <label className="form-check-label" htmlFor="isActiveEdit">Kullanıcı Aktif</label>
                  </div>

                  {editingUser.role !== 'admin' && (
                    <div className="mb-3">
                      <label className="form-label fw-bold">Erişim İzinleri</label>
                      <div className="table-responsive border rounded p-2 bg-light">
                        <table className="table table-sm table-borderless mb-0">
                          <thead>
                            <tr>
                              <th>Sayfa</th>
                              <th className="text-center">Gör</th>
                              <th className="text-center">Ekle</th>
                              <th className="text-center">Düz</th>
                              <th className="text-center">Sil</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resources.map(res => (
                              <tr key={res.key}>
                                <td>{res.label}</td>
                                {['view', 'create', 'edit', 'delete'].map(action => (
                                  <td key={action} className="text-center">
                                    <input 
                                      type="checkbox" 
                                      className="form-check-input"
                                      checked={editingUser.permissions?.[res.key]?.[action] || false}
                                      onChange={() => handleEditPermissionChange(res.key, action)}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={() => setEditingUser(null)}>İptal</button>
                    <button type="submit" className="btn btn-primary">Güncelle</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
